import * as React from 'react';
import * as Styled from './Sparrow.styles';
import useSurveySparrow from './useSurveySparrow';
import { useQuestionnairePageContext } from '@ids/context/QuestionnairePage';
import { useIdsGaTracking } from '@ids/hooks';
import { useConfig } from '@ids/appshell';

declare global {
    interface Window {
        SparrowLauncher: (name: string, options: Record<string, unknown> | number | boolean | string) => void;
        SS_ACCOUNT: string;
        SS_SURVEY_NAME: string;
        SS_WIDGET_TOKEN: string;
    }
}

const WWSS_ACCOUNT = 'westwingstudio.surveysparrow.com';
const WWSS_SURVEY_NAME = 'dein-eigenes-projekt';

const SurveySparrow = () => {
    const config = useConfig();
    const surveySparrowRef = React.useRef<HTMLElement>(null);
    const [isFormLoading, setIsFormLoading] = React.useState(true);
    const { trackIdsEvent } = useIdsGaTracking();
    const questionnairePageData = useQuestionnairePageContext();

    const showForm = React.useCallback(() => {
        setIsFormLoading(false);
        if (surveySparrowRef.current) {
            surveySparrowRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const handleSurveySparrowMessage = React.useCallback(
        (event: MessageEvent) => {
            if (event?.data?.type === 'surveyLoadStarted') {
                showForm();
                trackIdsEvent({
                    category: 'Screen show',
                    label: 'sparrow_view',
                });
            }
            if (event?.data?.type === 'surveyCompleted') {
                trackIdsEvent({
                    category: 'Questionnaire Interaction',
                    label: 'sparrow_completed',
                });
            }
        },
        [showForm, trackIdsEvent]
    );

    const handleSurveySparrowLoad = React.useCallback(() => {
        if (surveySparrowRef.current && surveySparrowRef.current.querySelector('iframe')) {
            showForm();
            window.SparrowLauncher('popup', {
                variables: { sparrowLang: config.countryCode },
            });
        }
    }, [showForm, config.countryCode]);

    useSurveySparrow(surveySparrowRef, handleSurveySparrowMessage);

    if (!questionnairePageData?.sparrowFormToken) {
        return <Styled.Wrapper $isLoading data-testid="survey-sparrow-form" />;
    }

    return (
        <Styled.Wrapper
            ref={surveySparrowRef}
            $isLoading={isFormLoading}
            onLoad={handleSurveySparrowLoad}
            data-testid="survey-sparrow-form"
        >
            <script
                /* eslint-disable */
                dangerouslySetInnerHTML={{
                    __html: `
                window.SS_WIDGET_TOKEN = ${JSON.stringify(questionnairePageData.sparrowFormToken)};
                window.SS_ACCOUNT = ${JSON.stringify(WWSS_ACCOUNT)};
                window.SS_SURVEY_NAME = ${JSON.stringify(WWSS_SURVEY_NAME)};
                function Sparrow(){Sparrow.update.apply(Sparrow,arguments)}
                Sparrow.args=[];
                Sparrow.update=function(){for(var r=arguments.length,a=new Array(r),p=0;p<r;p++)a[p]=arguments[p];Sparrow.args.push(a)};
                window.SparrowLauncher=Sparrow;`,
                }}
                /* eslint-enable */
            />
            <script
                type="text/javascript"
                id="ss-widget"
                defer
                src={`//${WWSS_ACCOUNT}/widget/${questionnairePageData.sparrowFormToken}`}
            />
        </Styled.Wrapper>
    );
};

export default SurveySparrow;
